import { render, staticRenderFns } from "./model-menu.component.vue?vue&type=template&id=8133033e&"
import script from "./model-menu.component.vue?vue&type=script&lang=js&"
export * from "./model-menu.component.vue?vue&type=script&lang=js&"
import style0 from "./model-menu.component.vue?vue&type=style&index=0&id=8133033e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports